export const getFileExt = (fileName: string): string => {
  return fileName?.split('.').pop() || '';
};
